export default class ModalFormController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {import('~/scripts/services/model/form').default} form
	 * @param {any} submission
	 * @param {any} options
	 */
	constructor(
		$scope,
		$timeout,
		$uibModalInstance,
		FormService,
		form,
		submission,
		options,
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.FormService = FormService;
		this.form = form;
		this.submission = submission;
		this.options = options;

		let methods = {};
		this.$timeout(() => {
			this.form.updateMap();
			methods = this.form.map;
		}, 500);

		this.$scope.$on('kmethod', (/** @type {Event} */ event, /** @type {any} */ data) => {
			/** @type {any} */
			const returnValue = {};

			for (const k in Object.keys(data)) {
				if (k in methods) {
					// @ts-ignore
					returnValue.front = [methods[k]];
					delete data[k];
					if ('params' in returnValue.front[0].params && returnValue.front[0].params.params === '__DATA__') {
						returnValue.front[0].params.params = data;
					}
				}
			}
			this.$uibModalInstance.close(returnValue);
		});
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		this.$uibModalInstance.close(this.submission);
	}
}
